import { render, staticRenderFns } from "./Subcategories.vue?vue&type=template&id=f2a260e4"
import script from "./Subcategories.vue?vue&type=script&lang=js"
export * from "./Subcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports